module.exports = __webpack_public_path__ + "static/media/video_sprite.1ad92e6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/video_sprite.mp4
// module id = 141
// module chunks = 1